import React,{Component} from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../common/PageTitle";
import Editor from "./Editor";
import SidebarActions from "./SidebarActions";


import firebase from '../firebase';
import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';
import { Redirect } from 'react-router';

export default class AddNewPost extends Component{


  constructor(props) {
    super(props);
  
    this.state = {photo_url:undefined,title:undefined,description:undefined,visibility:'Public',loading:false,logged_in:false};
    
    this.changeVisibility = this.changeVisibility.bind(this);
    this.changeUrl = this.changeUrl.bind(this);
    this.removeUrl = this.removeUrl.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.upload_post = this.upload_post.bind(this);
    this.get_todays_date_String = this.get_todays_date_String.bind(this);
    this.isUndefined = this.isUndefined.bind(this);
    this.upload_post = this.upload_post.bind(this);
  }

  changeVisibility = () =>{
        if(this.state.visibility === "Public"){
            this.setState({visibility:'Private'});
        }
        else{
            this.setState({visibility:'Public'});
        }
  }

  changeUrl = (url) =>{
      this.setState({photo_url:url});
  }

  removeUrl=(evt)=>{
      evt.preventDefault();
      this.setState({photo_url:undefined});
  }

  handleChange = (data) =>{
      this.setState(data);
  }

  get_todays_date_String =()=>{
    var date = new Date();
    var string_date = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+(date.getDate());
    return string_date;
  }

  isUndefined = (obj)=>{
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if(obj[key]===undefined){
            return true;
          }
      }      
    }
    return false;
  }

  upload_post = ()=>{

      var that = this;
      
      console.log("function called");

      var data = {
          photo_url:this.state.photo_url,
          title:this.state.title,
          description:this.state.description,
          visibility:this.state.visibility,
          date: this.get_todays_date_String(),
      }
      console.log(data);

      if(this.isUndefined(data) ){
          toast("Please Enter All the fields",{containerId:"A"});
          return
      }


      var func_ref = firebase.functions().httpsCallable('AddPost');  
                         
        this.setState({loading:true});      

        func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var rdata = result.data;
                  console.log(rdata);
                  if(rdata.status==="success"){
                        console.log("Document succesfully added!");
                        toast('Post  Added Successfully !', {containerId: 'A'});

                   }
                  else{
                        toast(rdata.error.message, {containerId: 'A'});
                        console.log(rdata.error.message);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable to add post", {containerId: 'A'});
        });


  }


   componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }





  render(){

    if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }

    return(

     <Container fluid className="main-content-container px-4 pb-4">
          {/* Page Header */}
          <Row noGutters className="page-header py-4">
                <PageTitle sm="4" title="Add New Post" subtitle="Posts" className="text-sm-left" />
          </Row>

          <Row>
            {
              !this.state.loading &&
              <Col lg="9" md="12">
                  
                    <Editor changePhotoUrl={this.changeUrl}
                            photo_url={this.state.photo_url}
                            remove_photo={this.removeUrl}
                            handleChange={this.handleChange}
                            />
                  
              </Col>
            }
            {
              !this.state.loading &&
            <Col lg="3" md="12">
                  <SidebarActions edit={this.changeVisibility}
                                  visibility={this.state.visibility}
                                  onPublish={this.upload_post}
                                  />
            </Col>
          }

            { 
              
                  (this.state.loading) &&
              <Col lg="9" md="12">
                  
                    <div style={{margin: '10%',marginLeft: '60%'}}>
                        <AtomSpinner color="blue" style={{marginLeft: '10%'}}/>  
                        <div style={{color:'blue',marginTop:'10%',textAlign: 'left' }}>
                          Adding  New Post ...          
                        </div>
                    </div>
          

                
              </Col>
            }

        </Row>
  </Container>
      )
  }
}


